
import { Link } from 'react-router-dom'
import { Stack } from '@mui/material'
import  logo  from '../assets/logo.png'
import SearchBar from './SearchBar'

 
const Navbar = () =>(
  <Stack 
    direction= "row"
    alignItmes= "center"
    p= {2}
    sx={{position: 'sticky', background: '#000', top: 0, justifyContent: 'space-between'}}
  >
    <Link to="/" style={{ display: 'flex', alignitems: 'center' }}>
      <img src={logo} alt="logo"  height={45}/>
    </Link>

    <SearchBar/>
    
  </Stack>
)

export default Navbar